<template>
  <main>
    <div class="container-fluid">
      <div
        class="page-header min-height-300"
        style="
          background-image: url('https://images.unsplash.com/photo-1531512073830-ba890ca4eba2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80');
          margin-right: -24px;
          margin-left: -34%;
        "
      >
        <span class="mask bg-gradient-primary opacity-6"></span>
      </div>
      <div class="card shadow-lg mt-n6">
        <div class="card-body p-3">
          <div class="row gx-4">
            <div class="col-auto my-auto">
              <div class="avatar avatar-xl position-relative">
                <img
                  :src="'data:image/*;base64,'+partner.image"
                  alt="profile_image"
                  class="shadow-sm img-fluid"
                  v-if="partner.image"
                />
                <img 
                  src="@/assets/img/person.jpeg"
                  alt="profile_image"
                  class="img-fluid" v-else/>
              </div>
            </div>
            <div class="col-auto">
              <div class="h-100">
                <p class="fw-bold mb-0">{{ partner.name }}</p>
                <p class="text-secondary text-sm mb-2">{{ partner.vendor_id }}</p>
                <div class="gap-2 d-grid d-flex">
                  <argon-button color="outline-secondary" size="xs" @click="edit = !edit" v-if="!edit && partner.editable">Edit Profile</argon-button>
                  <button class="btn btn-primary btn-xs" v-if="edit" @click="updateProfile">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                    Save Change
                  </button>
                  <button class="btn btn-outline-secondary btn-xs" v-if="edit" @click="discard">Discard</button>
                </div>
              </div>
            </div>
            <div
              class="mx-auto mt-3 col-lg-5 col-md-6 my-sm-auto ms-sm-auto me-sm-0"
            >
              <div class="nav-wrapper position-relative end-0">
                <ul
                  class="p-1 bg-transparent nav nav-pills nav-fill"
                  role="tablist"
                >
                <template v-for="item,i in tab" :key="i">
                  <li class="nav-item" v-if="item.active">
                    <a
                      class="px-0 py-1 mb-0 nav-link active"
                      data-bs-toggle="tab"
                      href="#"
                      role="tab"
                      @click="showTab(i)"
                      aria-selected="true"
                    >
                      <i :class="'fa ' + item.icon" aria-hidden="true"></i>
                      <span class="ms-1 text-sm">{{ item.name }}</span>
                    </a>
                  </li>
                </template>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-12">

          <div class="card mb-2" v-if="tab[0].visible && tab[0].active">
            <div class="card-body">
              <p class="text-uppercase text-sm">Company Information</p>
              <div class="row">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Phone Number</label
                  >
                  <input v-model="partner.phone" type="text" class="form-control" :readonly="!edit">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Email address</label
                  >
                  <input v-model="partner.email" type="email" class="form-control" :readonly="!edit">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >NPWP</label
                  >
                  <input v-model="partner.vat" type="text" class="form-control" :readonly="!edit">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Tax Identity</label
                  >
                  <input v-model="partner.tax_identity" type="text" class="form-control" readonly="true">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Website</label
                  >
                  <input v-model="partner.website" type="text" class="form-control" :readonly="!edit">
                </div>
              </div>
            </div>
          </div>

          <div class="card" v-if="tab[1].visible&& tab[1].active">
            <div class="card-body">
              <p class="text-uppercase text-sm">Address Information</p>
              <div class="row">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Street</label
                  >
                  <input
                    v-model="partner.street"
                    type="text"
                    class="form-control"
                    :readonly="!edit"
                  />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Street 2</label
                  >
                  <input
                    v-model="partner.street2"
                    type="text"
                    class="form-control"
                    :readonly="!edit"
                  />
                </div>
                <div class="col-md-4">
                  <label for="example-text-input" class="form-control-label"
                    >City</label
                  >
                  <input 
                    v-model="partner.city"
                    type="text" 
                    class="form-control"
                    :readonly="!edit"/>
                </div>
                <div class="col-md-4">
                  <label for="example-text-input" class="form-control-label"
                    >Country</label
                  >
                  <select v-model="partner.country_id" class="form-select" :disabled="!edit" @change="getProvince(partner.country_id)">
                    <option 
                      v-for="country in country_list"
                      :key="country.id"
                      :value="country.id"
                      >{{ country.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label for="example-text-input" class="form-control-label"
                    >Province</label
                  >
                  <select v-model="partner.state_id" class="form-select" :disabled="!edit">
                    <option 
                      v-for="prov in province_list"
                      :key="prov.id"
                      :value="prov.id" 
                      >
                      {{ prov.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label for="example-text-input" class="form-control-label"
                    >Postal code</label
                  >
                  <input v-model="partner.zip" type="text" class="form-control" :readonly="!edit"/>
                </div>
              </div>
              <hr class="horizontal dark" />
              <div class="d-flex justify-content-between">
                <p class="text-uppercase text-sm">Other Address</p>
                <button class="btn btn-xs btn-outline-secondary" data-bs-toggle="modal" data-bs-target="#modalAddAddress" v-if="edit">
                  <i class="fa fa-plus" aria-hidden="true"></i> Add new
                </button>
              </div>
              <div class="row">
                <div class="col-md-4 mb-2" v-for="address,i in partner.other_address" :key="i">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-2">
                          <i class="fa fa-truck text-primary" aria-hidden="true" v-if="address.type == 'delivery'"></i>
                          <i class="fa fa-money text-primary" aria-hidden="true" v-if="address.type == 'invoice'"></i>
                        </div>
                        <div class="col">
                          <p class="fw-bold mb-0">{{ address.name }}</p>
                          <p class="text-secondary text-sm mb-0">{{ address.street }} {{address.street2}}</p>
                          <p class="text-secondary text-sm mb-0">{{ address.city }} {{ address.state }} {{ address.zip }}</p>
                          <p class="text-secondary text-sm mb-0">{{ address.country }}</p>
                          <p class="text-secondary text-sm mb-0" v-if="address.phone">Phone: {{ address.phone }}</p>
                          <p class="text-secondary text-sm mb-0" v-if="address.email">Email: {{ address.email }}</p>
                        </div>
                      </div>
                      <div class="d-grid gap-4 d-flex mt-3 mb-0 p-0 float-end" v-if="edit">
                        <div class="btn btn-xs btn-link m-0 p-0" @click="editAddress(i)" data-bs-toggle="modal" data-bs-target="#modalAddAddress">
                          <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Edit
                        </div>
                        <div class="btn btn-xs btn-link text-danger m-0 p-0" @click="deleteAddress(i)">
                          <i class="fa fa-trash" aria-hidden="true"></i> Delete
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card" v-if="tab[2].visible && tab[2].active">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <p class="text-uppercase text-sm">Due Diligence</p>
                <!-- <button class="btn btn-xs btn-outline-secondary" data-bs-toggle="modal" data-bs-target="#modalAddAwarding" v-if="edit">
                  <i class="fa fa-plus" aria-hidden="true"></i> Add new
                </button> -->
              </div>
              <div class="table-response">
                <table class="table">
                  <thead class="text-xs bg-light">
                    <th class="ps-2">#</th>
                    <th class="ps-2">Document Name</th>
                    <th class="ps-2">Document File</th>
                    <th class="ps-2"></th>
                  </thead>
                  <tbody class="text-xs">
                    <tr v-for="document,i in partner.due_diligent_ids" :key="document.document_id">
                      <td>{{ i+1 }}</td>
                      <td>{{ document.name }}</td>
                      <template v-if="document.url_data || document.file">
                        <td>
                          <a v-if="document.url_data" class="text-primary" :href="document.url_data" target="_blank">Open <i class="fa fa-external-link"></i></a>
                          <a class="text-primary" :href="document.url_data" target="_blank" v-else>{{ document.filename }}</a>
                        </td>
                        <td>
                          <button v-if="edit" class="btn btn-link text-danger btn-xs p-0" @click="clearDoc(i)">
                            <i class="fa text-sm fa-times" aria-hidden="true"></i> Clear
                          </button>
                        </td>
                      </template>
                      <template v-else>
                        <td v-if="edit">
                          <input type="file" class="form-control" :accept="partner.allowed_extensions" :ref="'documentUpload' + i" @change="getDocument($event,i)"/>
                        </td>
                      </template>
                    </tr>
                  </tbody>
                </table>
              </div>
              <hr class="horizontal dark" />
            </div>
          </div>

          <div class="card" v-if="tab[3].visible && tab[3].active">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <p class="text-uppercase text-sm">Contacts</p>
                <button class="btn btn-xs btn-outline-secondary" data-bs-toggle="modal" data-bs-target="#modalAddPIC" v-if="edit">
                  <i class="fa fa-plus" aria-hidden="true"></i> Add new
                </button>
              </div>
              <div class="row">
                <div class="col-md-4" v-for="p,i in partner.pic" :key="i">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-3">
                          <img
                            src="../assets/img/person.jpeg"
                            alt="pic_image"
                            class="shadow-sm w-100 border-radius-lg"
                          />
                        </div>
                        <div class="col-9">
                          <p class="fw-bold mb-0">{{ p.name }}</p>
                          <p class="text-secondary text-sm mb-0">{{ p.function }}</p>
                          <p class="text-secondary text-sm mb-0">{{ p.email }}</p>
                          <p class="text-secondary text-sm mb-0" v-if="p.phone">Phone: {{ p.phone }}</p>
                        </div>
                      </div>
                      <div class="d-grid gap-4 d-flex mt-3 mb-0 p-0 float-end" v-if="edit">
                        <div class="btn btn-xs btn-link m-0 p-0" @click="editPIC(i)" data-bs-toggle="modal" data-bs-target="#modalAddPIC">
                          <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Edit
                        </div>
                        <div class="btn btn-xs btn-link text-danger m-0 p-0" @click="deletePIC(i)">
                          <i class="fa fa-trash" aria-hidden="true"></i> Delete
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card" v-if="tab[4].visible && tab[4].active">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <p class="text-uppercase text-sm">Password</p>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Old Password</label
                  >
                  <input v-model="settings.old_pw" type="password" class="form-control">
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >New Password</label
                  >
                  <input v-model="settings.new_pw" type="password" class="form-control">
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Confirm New Password</label
                  >
                  <input v-model="settings.confirm_new_pw" type="password" class="form-control">
                </div>
              </div>
              <div class="mt-3">
                <p class="text-danger text-xs my-2" v-if="!settings.old_pw_ok">Old Password incorrect!</p>
                <p class="text-danger text-xs my-2" v-if="(settings.new_pw && settings.confirm_new_pw) && (settings.new_pw !== settings.confirm_new_pw)">New Password doesn't match</p>
                <button class="btn btn-primary btn-sm" @click="pokeChangePassword">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading_pw"></span>
                  Change Password
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- modal -->
    <div class="modal fade" id="modalAddPIC" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="modalAddPICLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <p class="modal-title" id="modalAddPICLabel">Contacts</p>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="col-md">
              <label for="name">Name</label>
              <input v-model="modal.name" type="text" class="form-control">
            </div>
            <div class="col-md">
              <label for="name">Job Position</label>
              <input v-model="modal.function" type="text" class="form-control">
            </div>
            <div class="col-md">
              <label for="name">Email</label>
              <input v-model="modal.email" type="email" class="form-control">
            </div>
            <div class="col-md">
              <label for="name">Phone</label>
              <input v-model="modal.phone" type="text" class="form-control">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-xs btn-primary" @click="addPIC">
              {{ indexPICEdited !== null ? 'Save' : 'Add' }}
            </button>
            <button ref="discardAddPIC" type="button" class="btn btn-xs btn-outline-secondary" data-bs-dismiss="modal">Discard</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalAddAddress" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="modalAddAddressLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <p class="modal-title" id="modalAddAddressLabel">Other Address</p>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="col-md">
              <div class="form-check form-check-inline">
                <input v-model="modal.type" class="form-check-input" type="radio" id="inlineRadio1" value="delivery">
                <label class="form-check-label" for="inlineRadio1">Delivery Address</label>
              </div>
              <div class="form-check form-check-inline">
                <input v-model="modal.type" class="form-check-input" type="radio" id="inlineRadio2" value="invoice">
                <label class="form-check-label" for="inlineRadio2">Invoice Address</label>
              </div>
            </div>
            <div class="col-md">
              <label for="name">Name</label>
              <input v-model="modal.name" type="text" class="form-control">
            </div>
            <label for="name">Address</label>
            <div class="row">
              <div class="col-md-12 mb-2">
                <input v-model="modal.street" type="text" class="form-control" placeholder="Street">
              </div>
              <div class="col-md-12 mb-2">
                <input v-model="modal.street2" type="text" class="form-control" placeholder="Street 2">
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4">
                <label for="name">Country</label>
                <select v-model="modal.country_id" class="form-select" @change="getProvince(modal.country_id)">
                    <option 
                      v-for="country in country_list"
                      :key="country.id"
                      :value="country.id"
                      >{{ country.name }}
                    </option>
                  </select>
              </div>
              <div class="col-sm-4">
                <label for="name">Province</label>
                <select v-model="modal.state_id" class="form-select">
                    <option 
                      v-for="prov in province_list"
                      :key="prov.id"
                      :value="prov.id" 
                      >
                      {{ prov.name }}
                    </option>
                  </select>
              </div>
              <div class="col-sm-4">
                <label for="name">City</label>
                <input v-model="modal.city" type="text" class="form-control">
              </div>
              <div class="col-sm-4">
                <label for="name">Zip</label>
                <input v-model="modal.zip" type="text" class="form-control">
              </div>
            </div>
            <div class="col-md">
              <label for="name">Phone</label>
              <input v-model="modal.phone" type="text" class="form-control">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-xs btn-primary" @click="addAddress">
              {{ indexAddressEdited !== null ? 'Save' : 'Add' }}
            </button>
            <button ref="discardAddAddress" type="button" class="btn btn-xs btn-outline-secondary" data-bs-dismiss="modal">Discard</button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import ArgonButton from "@/components/ArgonButton.vue";
const endpoint = require("../router/endpoint");

const body = document.getElementsByTagName("body")[0];

export default {
  name: "profile",
  data() {
    return {
      showMenu: false,
      tab: [
        {
          'name': 'Info',
          'icon': 'fa-cubes',
          'visible': true,
          'active': true
        },
        {
          'name': 'Address',
          'icon': 'fa-building',
          'visible': false,
          'active': true
        },
        {
          'name': 'Document',
          'icon': 'fa-folder-open',
          'visible': false,
          'active': true
        },
        {
          'name': 'Contacts',
          'icon': 'fa-users',
          'visible': false,
          'active': true
        },
        {
          'name': 'Settings',
          'icon': 'fa-cog',
          'visible': false,
          'active': true
        },
      ],
      partner: {},
      loading: false,
      edit: false,
      indexPICEdited: null,
      indexAddressEdited: null,
      indexCertificateEdited: null,
      indexAwardingEdited: null,
      uploaded: false,
      loading_pw: false,
      settings: {
        old_pw: null,
        new_pw: null,
        confirm_new_pw: null,
        old_pw_ok: true
      },
      modal: {
        id: null,
        image: null,
        name: null,
        phone: null,
        email: null,
        function: null, // job position
        type: null,
        street: null,
        street2: null,
        city: null,
        country_id: null,
        country: null,
        state_id: null,
        state: null,
        zip: null,
        file: null,
        filename: null,
      },
      country_list: [],
      province_list: []
    };
  },
  components: { ArgonButton },
  methods: {
    async pokeChangePassword() {
      this.loading_pw = true
      this.axios.post(endpoint.UPDATE_PASS, {
        user_password: this.settings.new_pw,
        user_partner_id: parseInt(localStorage.getItem('partner_user')),
        user_old_password: this.settings.old_pw
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      })
        .then(response => {
          if (response.data.response_code === '0000') {
            this.$notify({
              type: 'success',
              title: 'Succes!',
              text: 'Your password has been updated!',
            });
            this.logout();
          }
          else {
            this.$notify({
              type: 'warn',
              title: 'Warning',
              text: response.data.message,
            });
            this.loading_pw = false
          }
          this.loading_pw = false
        })
        .catch(e => {
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message || e,
          });
          this.loading_pw = false
        })
    },
    async uploadDocument() {
      try {
        this.loading = true;

        var req_empty = 0;
        this.partner.due_diligent_ids.forEach((doc) => {
          if (doc.required) {
            if (!doc.file && !doc.url_data) {
              req_empty = req_empty + 1;
            }
          }
        });

        if (req_empty > 0) {
          this.$notify({
            type: 'warn',
            title: 'Warning!',
            text: 'Required documents must be uploaded!',
          });
          this.loading = false;
          return;
        }

        for (const [i, doc] of this.partner.due_diligent_ids.entries()) {
          if (doc.file) {
            const params = {
              files_to_upload: doc.file,
              file_to_upload_filename: doc.filename,
              model_name: 'bh.document.vendor',
              model_id: parseInt(doc.due_diligence_id.split('_')[0]),
              partner_id: parseInt(localStorage.getItem('partner_id')),
              document_id: parseInt(doc.document_id.split('_')[0]),
            };

            try {
              const response = await this.axios.post(
                endpoint.UPLOAD_DOCUMENT,
                params,
                {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                  },
                }
              );

              if (response.data.msg_status === '0002') {
                this.$notify({
                  type: 'warn',
                  title: 'Expired',
                  text: 'Session expired, please sign in again.',
                });
                this.$router.replace('/signin');
                return false;
              } else if (response.data.response_code === '0000') {
                this.partner.due_diligent_ids[i].url_data =
                  response.data.data.url_data;
                // this.loading = false;
                // this.uploaded = true;
              } else {
                if (response.data.response_code !== '4000') {
                  this.$notify({
                    type: 'warn',
                    title: 'Warning',
                    text: response.data.message,
                  });
                }
                this.loading = false;
                return false;
              }
            } catch (e) {
              if (e.response && e.response.status === 413) {
                // Handle error 413 Payload Too Large
                this.$notify({
                  type: 'error',
                  title: 'Payload Too Large',
                  text: 'The file size is too large. Please upload a smaller file.',
                });
              } else {
                // Handle other errors
                this.$notify({
                  type: 'error',
                  title: 'Something went wrong!',
                  text: e.response.data.message || e,
                });
              }

              this.loading = false;
              return false;
            }
          }
        }

        return true;
      } catch (error) {
        console.error('Error in uploadDocument:', error);
        this.loading = false
        return false;
      }
    },
    reuploadDocument(e, i, doc) {
      e.preventDefault()
      const params = {
          files_to_download: doc.filename,
          model_name: 'bh.document.vendor',
          model_id: doc.due_diligence_id.split('_')[0],
        }
      this.axios
        .post(
          endpoint.DOWNLOAD_DOCUMENT,
          params,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
          } else if (response.data.response_code === "0000") {
            this.partner.due_diligent_ids[i].url_data = response.data.data.url_data.url
            const downloadLink = document.createElement("a");
            downloadLink.href = response.data.data.url_data.url;
            downloadLink.target = '_blank';
            downloadLink.click();
            // this.loading = false;
          } else {
              if (response.data.response_code !== "4000"){
              this.$notify({
                  type: 'warn',
                  title: 'Warning',
                  text: response.data.message,
              });}
              // this.loading = false;
          }
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message || e,
          });
          // this.loading = false;
        });
    },
    getDocument(event, index) {
      const fileInput = this.$refs['documentUpload' + index];
      const file = event.target.files[0];

      // Validasi ukuran file maksimum (misalnya, 20 MB)
      const maxSizeInBytes = this.partner.limit_file * 1024 * 1024; // 20 MB
      if (file.size > maxSizeInBytes) {
        // Tampilkan pesan atau ambil tindakan yang sesuai
        alert(`File size exceeds the maximum allowed size (${this.partner.limit_file} MB). Please choose a smaller file.`);

        // Kosongkan input file
        fileInput.value = null;

        return;
      }
      this.partner.due_diligent_ids[index].file_size = file.size
      const reader = new FileReader();
      reader.onload = e => { 
        this.partner.due_diligent_ids[index].file = e.target.result.split(',')[1];
      };

      reader.readAsDataURL(file);
      this.partner.due_diligent_ids[index].filename = file.name;
    },
    getAttachmentBinary (event) {
      var file = event.target.files[0]
      const reader = new FileReader()
      reader.onload = e => { 
        this.modal.file = e.target.result.split(',')[1]
      }
      reader.readAsDataURL(file)
      this.modal.filename = event.target.files[0].name
    },
    getSiupBinary (event) {
      var file = event.target.files[0]
      const reader = new FileReader()
      reader.onload = e => { 
        this.partner.siup_file = e.target.result.split(',')[1]
      }
      reader.readAsDataURL(file)
      this.partner.siup_filename = event.target.files[0].name
    },
    getAktaBinary (event) {
      var file = event.target.files[0]
      const reader = new FileReader()
      reader.onload = e => { 
        this.partner.akta_file = e.target.result.split(',')[1]
      }
      reader.readAsDataURL(file)
      this.partner.akta_filename = event.target.files[0].name
    },
    getNpwpBinary (event) {
      var file = event.target.files[0]
      const reader = new FileReader()
      reader.onload = e => { 
        this.partner.npwp_file = e.target.result.split(',')[1]
      }
      reader.readAsDataURL(file)
      this.partner.npwp_filename = event.target.files[0].name
    },
    clearDoc(index) {
      this.partner.due_diligent_ids[index].url_data = null
      this.partner.due_diligent_ids[index].file = null
      this.partner.due_diligent_ids[index].filename = null
      this.partner.due_diligent_ids[index].file_size = null
    },
    clearModalVals() {
      this.modal.name = null
      this.modal.phone = null
      this.modal.email = null
      this.modal.function = null
      this.modal.type = null
      this.modal.street = null
      this.modal.street2 = null
      this.modal.city = null
      this.modal.country_id = null
      this.modal.country = null
      this.modal.state_id = null
      this.modal.state = null
      this.modal.zip = null
      this.modal.file = null
      this.modal.filename = null
    },
    addCertificate() {
      var vals = {
        'id': this.modal.id,
        'name': this.modal.name,
        'file': this.modal.file,
        'filename': this.modal.filename
      }
      if (this.modal.name && this.modal.file) {
        if (this.indexCertificateEdited !== null) {
          this.partner.certification_ids[this.indexcertificateEdited].name = this.modal.name
          this.partner.certification_ids[this.indexcertificateEdited].file = this.modal.file
          this.partner.certification_ids[this.indexcertificateEdited].filename = this.modal.filename
          this.indexcertificateEdited = null
        } else {
          this.partner.certification_ids.push(vals)
        }
        this.clearModalVals()
        this.$refs.discardAddCertificate.click();
      } else {
        this.$notify({
          type: 'warn',
          title: 'Warning',
          text: 'Name and File are required!',
        });
      }
    },
    deleteCertificate(index) {
      this.partner.certification_ids.splice(index,1)
    },
    addAwarding() {
      var vals = {
        'id': this.modal.id,
        'name': this.modal.name,
        'file': this.modal.file,
        'filename': this.modal.filename
      }
      if (this.modal.name && this.modal.file) {
        if (this.indexAwardingEdited !== null) {
          this.partner.awarding_ids[this.indexAwardingEdited].name = this.modal.name
          this.partner.awarding_ids[this.indexAwardingEdited].file = this.modal.file
          this.partner.awarding_ids[this.indexAwardingEdited].filename = this.modal.filename
          this.indexAwardingEdited = null
        } else {
          this.partner.awarding_ids.push(vals)
        }
        this.clearModalVals()
        this.$refs.discardAddAwarding.click();
      } else {
        this.$notify({
          type: 'warn',
          title: 'Warning',
          text: 'Name and File are required!',
        });
      }
    },
    deleteAwarding(index) {
      this.partner.awarding_ids.splice(index,1)
    },
    addPIC() {
      var vals = {
        'id': this.modal.id,
        'image': this.modal.image,
        'name': this.modal.name,
        'phone': this.modal.phone,
        'email': this.modal.email,
        'function': this.modal.function,
      }
      if (this.modal.name && this.modal.phone) {
        if (this.indexPICEdited !== null) {
          this.partner.pic[this.indexPICEdited].image = this.modal.image
          this.partner.pic[this.indexPICEdited].name = this.modal.name
          this.partner.pic[this.indexPICEdited].phone = this.modal.phone
          this.partner.pic[this.indexPICEdited].email = this.modal.email
          this.partner.pic[this.indexPICEdited].function = this.modal.function
          this.indexPICEdited = null
        } else {
          this.partner.pic.push(vals)
        }
        this.clearModalVals()
        this.$refs.discardAddPIC.click();
      } else {
        this.$notify({
          type: 'warn',
          title: 'Warning',
          text: 'Name and Phone are required!',
        });
      }
    },
    editPIC(index) {
      this.indexPICEdited = index
      this.modal.id = this.partner.pic[index].id 
      this.modal.image = this.partner.pic[index].image 
      this.modal.name = this.partner.pic[index].name 
      this.modal.phone = this.partner.pic[index].phone 
      this.modal.email = this.partner.pic[index].email 
      this.modal.function = this.partner.pic[index].function 
    },
    deletePIC(index) {
      this.partner.pic.splice(index,1)
    },
    addAddress() {
      var vals = {
        'id': this.modal.id,
        'name': this.modal.name,
        'phone': this.modal.phone,
        'email': this.modal.email,
        'street': this.modal.street,
        'street2': this.modal.street2,
        'city': this.modal.city,
        'state_id': this.modal.state_id ? parseInt(this.modal.state_id) : null,
        'state': this.modal.state,
        'country_id': this.modal.country_id ? parseInt(this.modal.country_id) : null,
        'country': this.modal.country,
        'zip': this.modal.zip,
        'type': this.modal.type
      }
      if (this.modal.type && this.modal.name) {
        if (this.indexAddressEdited !== null) {
          this.partner.other_address[this.indexAddressEdited].name = this.modal.name
          this.partner.other_address[this.indexAddressEdited].phone = this.modal.phone
          this.partner.other_address[this.indexAddressEdited].email = this.modal.email
          this.partner.other_address[this.indexAddressEdited].street = this.modal.street
          this.partner.other_address[this.indexAddressEdited].street2 = this.modal.street2
          this.partner.other_address[this.indexAddressEdited].city = this.modal.city
          this.partner.other_address[this.indexAddressEdited].state_id = this.modal.state_id ? parseInt(this.modal.state_id) : null
          this.partner.other_address[this.indexAddressEdited].state = this.modal.state
          this.partner.other_address[this.indexAddressEdited].country_id = this.modal.country_id ? parseInt(this.modal.country_id) : null
          this.partner.other_address[this.indexAddressEdited].country = this.modal.country
          this.partner.other_address[this.indexAddressEdited].zip = this.modal.zip
          this.partner.other_address[this.indexAddressEdited].type = this.modal.type
          this.indexAddressEdited = null
        } else {
          this.partner.other_address.push(vals)
        }
        this.clearModalVals()
        this.$refs.discardAddAddress.click();
      } else {
        this.$notify({
          type: 'warn',
          title: 'Warning',
          text: 'Address Type, Name, Address, and Phone are required!',
        });
      }
    },
    editAddress(index) {
      this.indexAddressEdited = index
      this.modal.id = this.partner.other_address[index].id 
      this.modal.name = this.partner.other_address[index].name 
      this.modal.phone = this.partner.other_address[index].phone 
      this.modal.email = this.partner.other_address[index].email 
      this.modal.street = this.partner.other_address[index].street 
      this.modal.street2 = this.partner.other_address[index].street2 
      this.modal.city = this.partner.other_address[index].city 
      this.modal.country_id = this.partner.other_address[index].country_id ? parseInt(this.partner.other_address[index].country_id) : null
      this.modal.country = this.partner.other_address[index].country 
      this.modal.state_id = this.partner.other_address[index].state_id ? parseInt(this.partner.other_address[index].state_id) : null
      this.modal.state = this.partner.other_address[index].state 
      this.modal.zip = this.partner.other_address[index].zip 
      this.modal.type = this.partner.other_address[index].type 
    },
    deleteAddress(index) {
      this.partner.other_address.splice(index,1)
    },
    showTab(index) {
      var next_tab = this.tab[index].name
      this.tab.forEach(x => {
        if (next_tab === x.name) {
          x.visible = true
        } else {
          x.visible = false
        }
      });
    },
    getProvince(country_id) {
      var partner_country_id = country_id.split('_')[0]
      this.province_list = []
      if (!partner_country_id){
        return
      }
      this.axios
        .post(
          endpoint.PROVINCE,
          {
            country_id: partner_country_id,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
          } else if (response.data.response_code === "0000") {
            response.data.data.forEach(line => {
              line.id = line.id.split('_')[0]
            });
            this.province_list = response.data.data;
          } else {
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message || e,
            });
        });
    },
    getCountry() {
      this.country_list = []
      this.axios
        .post(
          endpoint.COUNTRY,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
          } else if (response.data.response_code === "0000") {
            response.data.data.forEach(line => {
              line.id = line.id.split('_')[0]
            });
            this.country_list = response.data.data;
          } else {
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message || e,
            });
        });
    },
    getPartnerDetail() {
      this.loading = true
      this.axios
        .post(
          endpoint.PARTNER_PROFILE,
          {
            partner_id: parseInt(localStorage.getItem('partner_id'))
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
          } else if (response.data.response_code === "0000") {
            this.partner = response.data.data;
            this.getCountry();
            if (this.partner.country_id){
              this.getProvince(this.partner.country_id);
            }
            this.partner.country_id = this.partner.country_id.split('_')[0]
            this.partner.state_id = this.partner.state_id.split('_')[0]
            if (this.partner.other_address.length > 0) {
              this.partner.other_address.forEach(line => {
                line.id = line.id ? parseInt(line.id.split('_')[0]) : null
                line.state_id = line.state_id ? parseInt(line.state_id.split('_')[0]) : null
                line.country_id = line.country_id ? parseInt(line.country_id.split('_')[0]) : null
              });
            }
          } else {
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false;
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message || e,
            });
        });
    },
    async save() {
      this.loading = true
      const params = {
        partner_id: parseInt(localStorage.getItem('partner_id')),
        edit: {
          phone: this.partner.phone,
          email: this.partner.email,
          vat: this.partner.vat,
          website: this.partner.website,
          street: this.partner.street,
          street2: this.partner.street2,
          city: this.partner.city,
          state_id: this.partner.state_id ? parseInt(this.partner.state_id.split('_')[0]) : null,
          country_id: this.partner.country_id ? parseInt(this.partner.country_id.split('_')[0]) : null,
          zip: this.partner.zip,
          pic: this.partner.pic,
          other_address: this.partner.other_address,
        }
      }
      this.axios
        .post(
          endpoint.PARTNER_PROFILE_UPDATE,
          params,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
          } else if (response.data.response_code === "0000") {
            this.$notify({
              type: 'success',
              title: 'Voila!',
              text: response.data.message,
            });
            this.getPartnerDetail()
          } else {
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
          this.edit = false
          this.loading = false
        })
        .catch((e) => {
          this.loading = false;
          this.$notify({
              type: 'error',
              title: 'Failed',
              text: e.response.data.message || e,
            });
        });
    },
    discard() {
      this.getPartnerDetail()
      this.edit = false
    },
    downloadAttachment (id,model,field,filename) {
      // this.loading = true
      const values = {
          res_id: id,
          res_model: model,
          res_field: field,
      }
      this.axios
          .post(
          endpoint.GET_ATTACHMENT_BINARY,
          values,
          {
              headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
              }
          }
          )
          .then((response) => {
            if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
          } else if (response.data.response_code === "0000") {
                const linkSource = `data:${response.data.data.mimetype};base64,${response.data.data.file}`;
                const downloadLink = document.createElement("a");
                const fileName = filename;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            } else {
                this.$notify({
                    type: 'warn',
                    title: 'Warning',
                    text: response.data.message,
                });
            }
            this.loading = false
          })
          .catch((e) => {
          this.loading = false;
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message || e,
              });
          });
    },
    updateProfile() {
      const totalFileSize = this.partner.due_diligent_ids.reduce((sum, document) => {
        // Periksa apakah document.file_size terdefinisi dan memiliki nilai numerik
        if (document.file_size !== undefined && typeof document.file_size === 'number' && !isNaN(document.file_size)) {
          return sum + document.file_size;
        } else {
          // Jika tidak valid, kembalikan nilai sum tanpa penambahan
          return sum;
        }
      }, 0);
      let limit_file = localStorage.getItem('limit_file') || 20; // default 20 jika tidak ada nilai dari localStorage
      const maxSizeInBytes = limit_file * 1024 * 1024; // Konversi MB ke bytes
      if (totalFileSize > maxSizeInBytes) {
        alert(`File size exceeds the maximum allowed size (${limit_file} MB). Please choose a smaller file.`);
      } else {
        this.uploadDocument().then((res) => {
          if (res) {
            this.save();
          }
        });
      }
    },
    logout() {
      this.axios
      .post(endpoint.SIGN_OUT, {
        partner_id: parseInt(localStorage.getItem('partner_id')),
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      })
        .then(response => {
          if (response.data.msg_status === "0002"){
              this.$store.dispatch('setLoginState', false)
              localStorage.removeItem('isLogin')
              localStorage.removeItem('token')
              localStorage.removeItem('name')
              localStorage.removeItem('partner_id')
              localStorage.removeItem('partner_code')
              localStorage.removeItem('partner_vat')

              this.$router.replace('/signin')
          } else if (response.data.msg_status === '0000') {
            this.$store.dispatch('setLoginState', false)
            localStorage.removeItem('isLogin')
            localStorage.removeItem('token')
            localStorage.removeItem('name')
            localStorage.removeItem('partner_id')
            localStorage.removeItem('partner_code')
            localStorage.removeItem('partner_vat')

            this.$router.replace('/signin')
          }
          else {
            this.$notify({
              type: 'warn',
              title: 'Warning!',
              text: response.data.message
            });
          }
        })
        .catch(e => {
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message || e,
          });
        })
    },
    changePassword() {
      if ( !this.settings.old_pw || !this.settings.new_pw || !this.settings.confirm_new_pw || (this.settings.new_pw !== this.settings.confirm_new_pw) ) {
        this.$notify({
          type: 'error',
          title: 'Warning!',
          text: 'All field are required!'
        });
        return false
      }
      this.loading_pw = true
      const params = {
        username: this.partner.email,
        password: this.settings.old_pw
      }
      this.axios.post(endpoint.SIGN_IN, params)
        .then(response => {
          if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
          } else if (response.data.response_code === '0000') {
            this.pokeChangePassword()
            this.settings.old_pw_ok = true
            this.loading_pw = false
          }
          else {
            this.settings.old_pw_ok = false
            this.loading_pw = false
          }
        })
        .catch(e => {
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message || e,
          });
          this.loading_pw = false
        })
    }
  },
  computed: {
    // a computed getter
    partnerId() {
      // `this` points to the component instance
      return localStorage.getItem('partner_id')
    }
  },
  mounted() {
    this.$store.state.isAbsolute = true;
    setNavPills();
    setTooltip();
    this.getPartnerDetail()
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = false;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>
